module.exports = require('./hasSomeKeys')
